import { TextField } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'

const RenderInput = ({
  params,
  displayLabel,
  placeholder,
  setOpen,
  denseHeight,
  colors,
}: {
  params
  displayLabel: string
  placeholder?: string
  setOpen: Dispatch<SetStateAction<boolean>>
  denseHeight: boolean
  colors?: { color: string; labelColor: string; WebkitTextFillColor: string }
}) => (
  <TextField
    {...params}
    label={displayLabel}
    placeholder={placeholder}
    InputLabelProps={{
      shrink: true,
      sx: {
        color: colors?.labelColor ?? 'text.primary',
        WebkitTextFillColor: colors?.labelColor ?? 'text.primary',
      },
    }}
    InputProps={{
      ...params.InputProps,
      endAdornment: null,
      sx: theme => ({
        color: colors?.color ?? theme.palette.text.highlight, // or text.secondary/highlight
        WebkitTextFillColor: colors?.WebkitTextFillColor ?? theme.palette.text.highlight, // ✅ for Safari support
      }),
    }}
    onFocus={() => setOpen(true)}
    sx={{
      // keep the root compact
      maxHeight: denseHeight ? 40 : 45,
      '& .MuiOutlinedInput-root': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
      },
      '& .MuiAutocomplete-inputRoot': {
        maxHeight: denseHeight ? 40 : 45,
        height: 45,
        p: 0,
        pl: 0.5,
        flexWrap: 'nowrap',
      },
      // 👇 this is the important part
      '& .MuiAutocomplete-input': {
        minWidth: 0,
        flex: '1 1 0',
        width: 0, // allow shrink inside flex
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis', // works for value & placeholder
      },
      // optional: ensure placeholder is visible + ellipsized
      '& .MuiInputBase-input::placeholder': {
        opacity: 0.7,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    }}
  />
)
export default RenderInput
